import { Route } from "@angular/router";
import { BesoinListComponent } from "./besoin-list.component";

export const BesoinListRouting: Route = {
  path: "list-besoin",
  component: BesoinListComponent,
  data: {
    breadcrumb: "Liste"
  }
};
